import { useEffect, useState } from 'react';
import Logo from "../../assets/logo_header.svg";
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/company", label: "Company" },
    { to: "/mission", label: "Mission" },
    { to: "/services", label: "Services" },
    { to: "/projects", label: "Projects" },
];

export const TopMenu = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => { setOpen(false); }, [location.pathname]);

    const navClasses = `fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
            ? 'bg-navy-950/95 backdrop-blur-md border-b border-white/10 py-2 shadow-lg'
            : 'bg-navy-950/70 backdrop-blur-sm py-4'
    }`;

    const linkClass = "text-white/90 text-sm font-medium no-underline hover:text-accent transition-colors duration-200";

    return (
        <>
            <nav className={navClasses}>
                <div className="container-px mx-auto max-w-7xl flex items-center justify-between gap-6">
                    <Link to="/" className="flex items-center shrink-0">
                        <img
                            src={Logo}
                            alt="Rocky Point Detailing"
                            className="h-10 md:h-14 w-auto"
                        />
                    </Link>

                    <div className="hidden md:flex items-center gap-8">
                        {NAV_LINKS.map(link => (
                            <Link key={link.to} to={link.to} className={linkClass}>{link.label}</Link>
                        ))}
                        <Link
                            to="/contact-us"
                            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-signal text-signal-ink text-sm font-semibold no-underline hover:bg-signal-hover transition-all"
                        >
                            Get a Quote
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </Link>
                    </div>

                    <button
                        className="md:hidden text-white text-2xl leading-none bg-transparent border-none cursor-pointer p-2"
                        onClick={() => setOpen(prev => !prev)}
                        aria-label="Toggle navigation"
                    >
                        {open ? '✕' : '☰'}
                    </button>
                </div>

                {open && (
                    <div className="md:hidden bg-navy-950/95 backdrop-blur-md border-t border-white/10">
                        <div className="container-px mx-auto max-w-7xl py-6 flex flex-col gap-4">
                            {NAV_LINKS.map(link => (
                                <Link key={link.to} to={link.to} className="text-white text-base font-medium no-underline hover:text-accent transition-colors">{link.label}</Link>
                            ))}
                            <Link
                                to="/contact-us"
                                className="inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-lg bg-signal text-signal-ink font-semibold no-underline w-fit"
                            >
                                Get a Quote
                            </Link>
                        </div>
                    </div>
                )}
            </nav>
        </>
    );
};
